import { useMemo } from 'react';

import type { CarouselCompatibleAttributes } from '@/types';

interface UseMobileCarouselSettingsProps {
  attributes: CarouselCompatibleAttributes;
  isViewportMobile: boolean;
}

const DEFAULT_SLIDER_CONTROLS_DISPLAY_TYPE = 'overlay';

export const useMobileCarouselSettings = ({ attributes, isViewportMobile }: UseMobileCarouselSettingsProps) => {
  const {
    // Desktop attributes
    columns,
    shouldScrollHorizontally,
    sliderControlsDisplayType,
    sliderControlsBackgroundColor,
    sliderControlsTextColor,
    sliderControlsBorderColor,

    // Mobile attributes
    mobileShouldScrollHorizontally,
    mobileSliderControlsDisplayType,
    mobileSliderControlsBackgroundColor,
    mobileSliderControlsTextColor,
    mobileSliderControlsBorderColor,
  } = attributes;

  const displayedSettings = useMemo(() => {
    if (isViewportMobile) {
      return {
        columns: '1',
        shouldScrollHorizontally:
          mobileShouldScrollHorizontally !== undefined ? mobileShouldScrollHorizontally : shouldScrollHorizontally,
        sliderControlsDisplayType:
          mobileSliderControlsDisplayType ?? sliderControlsDisplayType ?? DEFAULT_SLIDER_CONTROLS_DISPLAY_TYPE,
        sliderControlsBackgroundColor: mobileSliderControlsBackgroundColor || sliderControlsBackgroundColor,
        sliderControlsTextColor: mobileSliderControlsTextColor || sliderControlsTextColor,
        sliderControlsBorderColor: mobileSliderControlsBorderColor || sliderControlsBorderColor,
      };
    }

    return {
      columns,
      shouldScrollHorizontally,
      sliderControlsDisplayType: sliderControlsDisplayType ?? DEFAULT_SLIDER_CONTROLS_DISPLAY_TYPE,
      sliderControlsBackgroundColor,
      sliderControlsTextColor,
      sliderControlsBorderColor,
    };
  }, [
    isViewportMobile,
    columns,
    shouldScrollHorizontally,
    sliderControlsDisplayType,
    sliderControlsBackgroundColor,
    sliderControlsTextColor,
    sliderControlsBorderColor,
    mobileShouldScrollHorizontally,
    mobileSliderControlsDisplayType,
    mobileSliderControlsBackgroundColor,
    mobileSliderControlsTextColor,
    mobileSliderControlsBorderColor,
  ]);

  return {
    isMobile: isViewportMobile,
    ...displayedSettings,
  };
};
